import { render, staticRenderFns } from "./ExternalPluginDialog.vue?vue&type=template&id=d4ba8578&scoped=true"
import script from "./ExternalPluginDialog.vue?vue&type=script&lang=js"
export * from "./ExternalPluginDialog.vue?vue&type=script&lang=js"
import style0 from "./ExternalPluginDialog.vue?vue&type=style&index=0&id=d4ba8578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ba8578",
  null
  
)

export default component.exports